import CASPartnerCopyWarning from './CASPartnerCopyWarning'

export default CASPartnerCopyWarning
